//--------------------------------------------------------------------//
//******************** call-history request helper ***********************//
//--------------------------------------------------------------------//
// Shared low-level fetch helper for talking to sip-gudhub-server's
// /call-history REST API (docs: sip-gudhub-server/docs/call-history).
import { GUDHUB_SETTINGS } from '../../../gudhub_settings.js';

export async function getCallHistory(userId) {
    const response = await fetch(`${GUDHUB_SETTINGS.sip_server_url}/call-history?user_id=${encodeURIComponent(userId)}`);
    const result = await response.json();

    if(!response.ok) {
        throw new Error(result.message || 'Call history request error');
    }

    return result;
}

// * callHistoryId (string) — entry.call_history_id
export function getRecordingUrl(callHistoryId) {
    return `${GUDHUB_SETTINGS.sip_server_url}/call-history/${encodeURIComponent(callHistoryId)}/recording`;
}
